import { DataArray } from "./DataArray"
import { PlayerIdBool, PlayerId } from "$types"
import { Match, SerializedGameState } from "$types/gameState"

export enum Event {
  CONNECTED = 0,
  DISCONNECTED = 1,
  ACTION_A_DOWN = 2,
  ACTION_B_DOWN = 3,
  MOVE_STOP = 4,
  MOVE_UP = 5,
  MOVE_DOWN = 6,
  MOVE_LEFT = 7,
  MOVE_RIGHT = 8,

}

export function createControllerMessage(event: Event, dataArray: DataArray, playerId = 1): DataArray {
  if (event < 0 || event > 8) throw new Error(`Invalid event: ${event}`)

  let increment = 0
  if (playerId > 1) {
    const offset = (playerId - 1)
    increment = (offset << 3) + (offset << 1)
  }

  dataArray.setUint8(0, event + increment)

  return dataArray
}

export function readControllerMessage(dataArray: DataArray): { playerId: 1 | 2 | 3 | 4, event: Event } {
  const message = dataArray.getInt8(0)

  const playerId = Math.floor(message / 10) + 1
  const event = message % 10

  if (event < 0 || event > 8) throw new Error(`Invalid event: ${event}`)
  if (playerId !== 1 && playerId !== 2 && playerId !== 3 && playerId !== 4) throw new Error(`Invalid playerId: ${playerId}`)

  return { playerId, event }
}

export type GameMessage = {
  type: "GAME_STARTED",
  startAt: string,
  activePlayers: PlayerIdBool
} | {
  type: "GET_CONNECTED_PLAYERS_IDS",
} | {
  type: "CONNECTED_PLAYERS_IDS",
  playerIds: PlayerId[]
} | {
  type: "GET_GAME_STATE",
} | {
  type: "GAME_STATE",
  gameState: SerializedGameState
} | {
  type: "END_MATCH",
  match: Match
} | {
  type: "END_GAME",
  endAt: string,
  winner: PlayerId
} | {
  type: "TIP_ADDED",
  tipAmount: number,
  prize: number
} | {
  type: "REDIRECT_TO_WITHDRAW",
} | {
  type: "REDIRECTED_TO_WITHDRAW"
} | {
  type: "CONTROLLER_CONNECTED",
  playerId: PlayerId
}

export function createGameMessage(message: GameMessage): string {
  return JSON.stringify(message)
}
